export default __webpack_public_path__ + "static/media/portfolio-83.96bfa527.jpg";